import angular from 'angular';
import SlidersT1Component from './sliders-t1.component';

let SlidersT1Module = angular.module('home.slidersT1', [])
  .component('slidersT1', SlidersT1Component);

export default SlidersT1Module;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/sliders/sliders-t1/sliders-t1.js
 **/